import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export interface HomeworkCommentChangeState {
    requests: {
        state: LoadStateInfo;
        request: HomeworkCommentChangeRequest
    }[];
}

const initialState: HomeworkCommentChangeState = {
    requests: [],
};
export function findHomeworkCommentRequest(requests: HomeworkCommentChangeState["requests"], payload: HomeworkCommentChangeRequest) {
    return requests.find((r) =>
        r.request.classroomId == payload.classroomId &&
        r.request.studentId == payload.studentId &&
        r.request.homeworkId == payload.homeworkId
    );
}
export interface HomeworkCommentChangeRequest {
    schoolId: number;
    classroomId: number;
    homeworkId: number;
    studentId: string;
    comment?: string;
}
export const homeworkCommentChange = createAsyncThunk(
    "homeworkCommentChange",
    async (param: HomeworkCommentChangeRequest, thunkAPI) => {
        console.debug(`change homework comment for classroom ${param.classroomId}, student ${param.studentId}, homework ${param.homeworkId} to comment ${param.comment}`);

        const response = await fetch(`${getBackendUrl()}/api/homework-comment/change`, {
            method: "POST",
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(param)
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    // {
    //     condition: (param: RoutineRecordChangeRequest, thunkAPI) => {
    //         const state = thunkAPI.getState() as RootState;
    //         const status = state.routineRecordList;
    //         if (!status || !status.state) {
    //             return true;
    //         }
    //         if (status.state.state == LoadState.NotStarted) {
    //             return true;
    //         }
    //         console.debug(`retrieveRoutineRecordList skipped: ${status.state.state}`);
    //         return false;
    //     }
    // }
);

export const homeworkCommentChangeSlice = createSlice({
    name: "homeworkCommentChangeList",
    initialState,
    reducers: {
        clear: (state, action: PayloadAction<HomeworkCommentChangeRequest>) => {
            const request = findHomeworkCommentRequest(state.requests, action.payload);
            if (request) {
                request.state = notStarted();
                request.request = action.payload;
            } else if (!request) {
                state.requests.push({
                    state: notStarted(),
                    request: action.payload
                });
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(homeworkCommentChange.pending, (state, action) => {
                const payload = action.meta.arg;
                const request = findHomeworkCommentRequest(state.requests, payload);
                if (request) {
                    request.state = loading();
                    request.request = payload;
                } else if (!request) {
                    state.requests.push({
                        state: loading(),
                        request: payload
                    });
                }
            })
            .addCase(homeworkCommentChange.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                const payload = action.meta.arg;
                const request = findHomeworkCommentRequest(state.requests, payload);
                if (request) {
                    request.state = loaded();
                    request.request = payload;
                }
            })
            .addCase(homeworkCommentChange.rejected, (state, action) => {
                const payload = action.meta.arg;
                const request = findHomeworkCommentRequest(state.requests, payload);
                if (request) {
                    request.state = error(action);
                    request.request = payload;
                }
            });
    },
});

// export const { } = homeworkCommentChangeSlice.actions;

export const selectHomeworkCommentChange = (state: RootState) => state.homeworkCommentChange;

export default homeworkCommentChangeSlice.reducer;
